import React from 'react';
import styled from 'styled-components/native';
import StudyNotificationList from '../../components/StudyNotificationList';

const StyledContainer = styled.View`
  flex: 1;
  background-color: white;
  align-items: center;
  justify-content: center;
`;

const StudyNotificationListExampleScreen: React.FC = () => {
  return (
    <StyledContainer>
      <StudyNotificationList
        data={[
          { title: '6.5 Hours', description: 'Average Sleep', image: '' },
          { title: '4 Days', description: 'Study Streak', image: '' },
          { title: 'On Week', description: 'In Chill Pill Study', image: '' },
          {
            title: 'Another Result',
            description: 'Chill Pill Study',
            image: ''
          }
        ]}
      />
    </StyledContainer>
  );
};

export default StudyNotificationListExampleScreen;
